import { render } from "./AccidentalDamageModal.vue?vue&type=template&id=6a75d162"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__